import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  inject,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import {
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { DashboardService } from '../../services/dashboard.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from '../../services/login-service/login.service';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { FormBuilder, FormGroup, FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dashboardpage',
  templateUrl: './dashboardpage.component.html',
  styleUrl: './dashboardpage.component.scss',
})
export class DashboardpageComponent implements OnInit, OnDestroy{
  displayedColumns: string[] = [
    'name',
    'created_by',
    'last_modified',
    'action',
  ];
  isLoading: boolean = false;
  isClassificationLoading: boolean = false;
  private dialogRef?: MatDialogRef<any>;
  @ViewChild('descriptionDialog') descriptionDialog!: TemplateRef<any>;
  ELEMENT_DATA = [];
  dataSource = this.ELEMENT_DATA;
  atlanStatus: boolean = false;
  files: any = [];
  total_files: number = 0;
  classificationDetail: any;
  snowflakeStatus: boolean = false;
  selectedFileName: string = '';
  user_role: any = '';
  form: FormGroup;
  selectedFile: File | null = null;
  private atlanHeathSubscription!: Subscription;
  private snowflakeHeathSubscription!: Subscription;
  private classificationListSubscription!: Subscription;
  private viewClassificationDetailSubscription!: Subscription;
  private downloadFileClassificationDetailSubscription!: Subscription;

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private dashboardService: DashboardService,
    private loginService: LoginService,
    private router: Router
  ) {
    this.form = this.fb.group({
      type: [null],
    });
  }
  ngOnInit(): void {
    this.loginService.loaderSubject.subscribe((response: any) => {
      if (response) {
        this.isLoading = true;
      } else {
        this.isLoading = true;
        this.getAtlanHeath();
        let user_detail: any = sessionStorage.getItem('user_details');
        let role = JSON.parse(user_detail);
        if (role) {
          this.user_role = role.user_roles[0];
          if (this.user_role?.includes('DATAENGINEER')) {
            this.user_role = 'DATA ENGINEER';
          } else if (this.user_role?.includes('DATAANALYST')) {
            this.user_role = 'DATA ANALYST';
          } else if (this.user_role?.includes('DATAARCHITECH')) {
            this.user_role = 'DATA ARCHITECTURE';
          }
        }
        this.dashboardService.roleSubject.next(this.user_role);
        localStorage.setItem('user_role', this.user_role);
      }
    });
  }

  getAtlanHeath() {
    const selectedNode: any = sessionStorage.getItem('selectedNode');
    const selectedEnv: any = sessionStorage.getItem('selectedEnv');
    this.atlanHeathSubscription = this.dashboardService.getAtlanHeath(selectedNode, selectedEnv).subscribe({
      next: (response: any) => {
        if (response?.status == 'healthy') {
          this.atlanStatus = true;
        } else {
          this.atlanStatus = false;
        }
        this.getSnowflakeHeath();
      },
      error: (err) => {
        this.toastr.error('Atlan Connection: Something went wrong', 'Error');
      },
    });
  }

  getSnowflakeHeath() {
    this.snowflakeHeathSubscription = this.dashboardService.getSnowflakeHeath().subscribe({
      next: (response: any) => {
        if (response?.connection_healthy) {
          this.snowflakeStatus = true;
        } else {
          this.snowflakeStatus = false;
        }
        this.getSavedList();
      },
      error: (err) => {
        this.toastr.error('Snowflake Connection: Something went wrong', 'Error');
      },
    });
  }

  getSavedList() {
    this.classificationListSubscription = this.dashboardService.getSavedList().subscribe({
      next: (response: any) => {
        if (response?.status == 'success') {
          this.files = response.files;
          this.files = this.files.slice(0, 10);
          this.total_files = response?.total_files;
        } else {
          this.files = [];
        }
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
      },
    });
  }

  openGenerateClassification(isAtlanSelected: boolean) {
    if (isAtlanSelected && !this.atlanStatus) {
      this.toastr.error(
        'This selection is disabled because Atlan is not connected. Please choose another option to proceed',
        'Error'
      );
      this.form.get('type')!.reset();
      return;
    }
    if (!isAtlanSelected && !this.snowflakeStatus) {
      this.toastr.error(
        'This selection is disabled because Snowflake is not connected. Please choose another option to proceed',
        'Error'
      );
      this.form.get('type')!.reset();
      return;
    }
    localStorage.setItem('isAtlanDatabase', JSON.stringify(isAtlanSelected));
    this.router.navigate(['/generate']);
  }

  viewClassification(filename: string) {
    this.isClassificationLoading = true;
    this.selectedFileName = filename;
    this.viewClassificationDetailSubscription = this.dashboardService.getFileClassificationDetails(filename).subscribe({
      next: (response: any) => {
        this.isClassificationLoading = false;
        this.classificationDetail = response?.data.metadata;
        this.dialogRef = this.dialog.open(this.descriptionDialog, {
          width: '800px',
          maxWidth: '90vw',
          height: 'auto',
          maxHeight: '90vh',
          disableClose: true,
          panelClass: 'description-dialog-panel',
        });
      },
      error: (err) => {
        this.toastr.error('Something went wrong', 'Error');
        this.isClassificationLoading = false;
      },
    });
  }

  downloadClassification(filename: string) {
    this.isClassificationLoading = true;
    this.downloadFileClassificationDetailSubscription = this.dashboardService.downloadFileClassificationDetail(filename).subscribe({
      next: (res) => {
        // Suggested Excel MIME
        const xlsxBlob = new Blob([res.body!], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const contentDisposition = res.headers.get('Content-Disposition');
        const fileName =
          this.extractFileName(contentDisposition) || 'report.xlsx';

        const url = URL.createObjectURL(xlsxBlob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        this.isClassificationLoading = false;
        this.dialogRef?.close();
        this.toastr.success('CSV file downloaded successfully', 'Downloaded');
      },
      error: (err) => {
        this.isClassificationLoading = false;
        this.toastr.error('Something went wrong', 'Error');
      },
    });
  }

  // Helper to parse filename from header
  extractFileName(contentDisposition: string | null): string | null {
    if (!contentDisposition) return null;
    // Handles filename= and RFC 5987 filename*
    const match =
      /filename\*=(?:UTF-8'')?["']?([^\"';]+)["']?/i.exec(contentDisposition) ||
      /filename=["']?([^\"']+)["']?/i.exec(contentDisposition);
    return match?.[1] ?? null;
  }

  onFileSelected(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files && inputElement.files.length > 0) {
      this.selectedFile = inputElement.files[0];
      const sizeBytes = this.selectedFile.size;
    } else {
      this.selectedFile = null;
    }
  }

  openFileUploadDialog() {
    const dialogRef = this.dialog.open(FileUploadDialog, {
      width: '1200px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.form.get('type')!.reset();
    });
  }

  copyJSON() {
    const text = JSON.stringify(this.classificationDetail, null, 2).trim();

    try {
      if (navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(text);
        this.toastr.success('Copied!');
      } else {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();

        const ok = document.execCommand('copy');
        document.body.removeChild(ta);
        if (ok) {
          this.toastr.info('Copied!');
        } else {
          this.toastr.error('Copy failed!');
        }
      }
    } catch (err) {
      this.toastr.error('Copy failed!');
    } finally {
    }
  }

  closeDescriptionDialog(): void {
    this.dialogRef?.close();
  }

  ngOnDestroy(): void {
    // Unsubscribe to avoid memory leaks
    if (this.atlanHeathSubscription) {
      this.atlanHeathSubscription.unsubscribe();
    }
    if (this.snowflakeHeathSubscription) {
      this.snowflakeHeathSubscription.unsubscribe();
    }
    if (this.classificationListSubscription) {
      this.classificationListSubscription.unsubscribe();
    }
    if (this.viewClassificationDetailSubscription) {
      this.viewClassificationDetailSubscription.unsubscribe();
    }
    if (this.downloadFileClassificationDetailSubscription) {
      this.downloadFileClassificationDetailSubscription.unsubscribe();
    }
  }
}

@Component({
  selector: 'file-upload',
  templateUrl: 'file-upload.html',
  styleUrls: ['file-upload.scss'],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class FileUploadDialog {
  readonly dialogRef = inject(MatDialogRef<FileUploadDialog>);

  // File handling properties
  selectedFile: File | null = null;
  allFiles: File[] = [];

  isDragOver = false;
  isUploading = false;
  error: string | null = null;
  customInstructions = '';

  // Configuration
  private readonly MAX_SIZE_BYTES = 2 * 1024 * 1024; // 2MB
  private readonly ALLOWED_EXTENSIONS = ['.csv'];
  private readonly ALLOWED_MIME_TYPES = [
    'text/csv',
    'application/vnd.ms-excel',
  ];

  constructor(
    public dialog: MatDialog,
    private dashboardService: DashboardService,
    private toastr: ToastrService
  ) { }

  // Drag and Drop Event Handlers
  @HostListener('dragover', ['$event'])
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();

    // Only set isDragOver to false if we're leaving the container entirely
    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    const x = event.clientX;
    const y = event.clientY;

    if (x < rect.left || x >= rect.right || y < rect.top || y >= rect.bottom) {
      this.isDragOver = false;
    }
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    const files = event.dataTransfer?.files;
    if (!files || files.length === 0) return;

    this.handleFileSelection(files);
  }

  // File Selection Handler
  onFileSelect(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      return;
    }

    this.handleFileSelection(input.files);

    // Clear input to allow selecting the same file again
    input.value = '';
  }

  // Centralized file handling
  private handleFileSelection(fileList: FileList): void {
    this.error = null;

    // Check if we already have the maximum number of files
    if (this.allFiles.length >= 1) {
      this.error = 'You can only upload one file at a time';
      this.toastr.error('You can only upload one file', 'Limit Exceeded!');
      return;
    }

    const file = fileList[0]; // Take only the first file

    // Validate file
    const validation = this.validateFile(file);
    if (!validation.isValid) {
      this.error = validation.error ?? null;
      this.toastr.error(validation.error, 'Invalid File');
      return;
    }

    // Add file to the list
    this.allFiles = [file]; // Replace any existing file
    this.selectedFile = file;
  }

  // File Validation
  private validateFile(file: File): { isValid: boolean; error?: string } {
    // Size validation
    if (file.size > this.MAX_SIZE_BYTES) {
      const sizeMB = (file.size / (1024 * 1024)).toFixed(2);
      const maxMB = (this.MAX_SIZE_BYTES / (1024 * 1024)).toFixed(0);
      return {
        isValid: false,
        error: `File is ${sizeMB} MB. Maximum allowed size is ${maxMB} MB.`,
      };
    }

    // Type validation
    const fileName = file.name.toLowerCase();
    const hasValidExtension = this.ALLOWED_EXTENSIONS.some((ext) =>
      fileName.endsWith(ext)
    );
    const hasValidMimeType = this.ALLOWED_MIME_TYPES.includes(file.type);

    if (!hasValidExtension && !hasValidMimeType) {
      return {
        isValid: false,
        error: 'Please select a CSV file only.',
      };
    }

    return { isValid: true };
  }

  // File Management
  removeFile(index: number): void {
    this.allFiles.splice(index, 1);
    this.selectedFile = this.allFiles.length > 0 ? this.allFiles[0] : null;
    this.error = null;
  }

  // Utility Methods
  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  // Helper to parse filename from response header
  private extractFileName(contentDisposition: string | null): string | null {
    if (!contentDisposition) return null;

    const match =
      /filename\*=(?:UTF-8'')?["']?([^\"';]+)["']?/i.exec(contentDisposition) ||
      /filename=["']?([^\"']+)["']?/i.exec(contentDisposition);

    return match?.[1] ?? null;
  }

  // Dialog Actions
  onCancel(): void {
    this.dialogRef.close();
  }

  validateAndGenerate(): void {
    if (!this.selectedFile) {
      this.toastr.error('Please select a file to proceed', 'Error');
      return;
    }

    this.isUploading = true;
    this.error = null;

    // Create form data for file upload
    const formData = new FormData();
    formData.append('file', this.selectedFile);

    if (this.customInstructions.trim()) {
      formData.append('custom_instruction', this.customInstructions.trim());
    }

    this.dashboardService.uploadFile(this.selectedFile, {'custom_instruction':this.customInstructions.trim()} ).subscribe({
      next: (res) => {
        this.isUploading = false;

        try {
          // Create blob for Excel file
          const xlsxBlob = new Blob([res.body!], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });

          // Get filename from response or use default
          const contentDisposition = res.headers.get('Content-Disposition');
          const fileName =
            this.extractFileName(contentDisposition) ||
            `classification_${new Date().getTime()}.xlsx`;

          // Download file
          const url = URL.createObjectURL(xlsxBlob);
          const downloadLink = document.createElement('a');
          downloadLink.href = url;
          downloadLink.download = fileName;
          downloadLink.style.display = 'none';

          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          URL.revokeObjectURL(url);

          // Show success message and close dialog
          this.toastr.success(
            'Classification Generated Successfully',
            'Downloaded'
          );
          this.dialogRef.close({ success: true, fileName });
        } catch (error) {
          this.error = 'Failed to process downloaded file';
          this.toastr.error('Failed to process the generated file', 'Error');
          this.dialogRef.close();
        }
      },
      error: (err) => {
        this.isUploading = false;
        // Handle different error types
        if (err.status === 400) {
          this.error = 'Invalid file format or content';
          this.toastr.error('Invalid file format or content', 'Error');
        } else if (err.status === 413) {
          this.error = 'File too large';
          this.toastr.error('File is too large', 'Error');
        } else if (err.status === 0) {
          this.error = 'Network connection error';
          this.toastr.error(
            'Please check your internet connection',
            'Connection Error'
          );
        }
        this.dialogRef.close();
      },
    });
  }

  // Getter for button state
  get isGenerateDisabled(): boolean {
    return !this.selectedFile || this.isUploading;
  }

  // Getter for upload progress text
  get uploadStatusText(): string {
    if (this.isUploading) {
      return 'Processing file...';
    }
    return 'Validate & Generate';
  }
}
